import { TESLA_MANUFACTURER_ID } from 'clipsal-cortex-utils/src/constants/common-constants';

export const GENERIC_BATTERIES_MANUFACTURER_IDS = [TESLA_MANUFACTURER_ID];
